import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as actions from '../redux/actions';
import * as commonActions from '../../common/redux/actions';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';
import { validateConstantType } from '../../../common/utils/validate';
import { selectVersionToCreate } from '../../../common/docs/content';
import CommonPageComponent from '../../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../../common/ui/AppSettingsNav';
import { checkVersionPermission } from '../../../common/utils/permissions';
import VersionTab from './VersionTab';
import { PROJECT_VERSION } from 'drapcode-constant';
import { getCookie, isProjectReadOnly } from '../../../common/utils/api_utils';

export class CreateProjectVersion extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { sourceVersion: '' };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
  }

  handleSubmit = (values) => {
    const { actions, match } = this.props;
    const { projectId, version } = match.params;
    const username = getCookie('username');
    const userId = getCookie('uuid');
    const name = getCookie('name');
    actions
      .createProjectVersion({ ...values, projectId, version, username, userId, name })
      .then(() => {
        actions.loadProjectVersion({ projectId });
        actions.loadProjectDetailAppSetting({ projectId, version });
      });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const { common, appSetting, match } = this.props;
    const { versions } = common;
    let options = versions.map((version) => ({
      value: `${version.currentVersion}`,
      label: `${version.currentVersion} (Created: ${convertTimeStampToDate(version.createdAt)})`,
    }));
    options = [{ value: '', label: selectVersionToCreate }, ...options];

    const { projectDetail, permissionFlags } = appSetting;
    if (!projectDetail) {
      return '';
    }

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { projectId, version } = match.params;
    const isAllowed = checkVersionPermission();
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'version'} projectDetail={projectDetail} />
        {!isAllowed ? (
          <PermissionDenied message="Project Version" />
        ) : (
          <>
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <ParentCardNoCol
                  bgColor="drapcode-violet"
                  icon="version"
                  title="Create Project Version"
                >
                  <Formik
                    initialValues={{ source: '' }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      !isReadOnly && this.handleSubmit(values);
                      setSubmitting(false);
                      resetForm();
                    }}
                  >
                    {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
                      return (
                        <Form className="form-horizontal">
                          <div className="row mx-auto">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                              <CustomInputWithIcon
                                required={true}
                                icon="select"
                                title="Name of Variable"
                              >
                                <Field
                                  as={CustomSelect}
                                  name="source"
                                  isMulti={false}
                                  options={options}
                                  onChange={setFieldValue}
                                  onBlur={setFieldTouched}
                                  onChangeValue={this.handleChange}
                                  validate={validateConstantType}
                                  placeholder="Select Source Version"
                                />
                                <ErrorMessage name="name">
                                  {(msg) => <p className="text-error">{msg}</p>}
                                </ErrorMessage>
                              </CustomInputWithIcon>
                            </div>
                            <div className="col-md-12 col-lg-12 mt-2 text-right d-flex justify-content-between">
                              <button
                                type="button"
                                className="btn btn-outline btn-md"
                                onClick={() => this.props.toggle('appConstant')}
                              >
                                <i className="wb webconnect-times"></i> Cancel
                              </button>
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-default btn-md"
                                  onClick={resetForm}
                                >
                                  <span>
                                    <i className={`wb ${drapcodeIcon('clear')}`}></i>&nbsp;Clear
                                  </span>
                                </button>
                                &nbsp;
                                <button
                                  type="submit"
                                  className="btn btn-theme-submit btn-md"
                                  disabled={isSubmitting || isReadOnly ? 'disabled' : ''}
                                  title={isReadOnly && 'Read-Only Mode'}
                                >
                                  <i className="wb webconnect-plus"></i>&nbsp; Create Version &nbsp;
                                </button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </ParentCardNoCol>
              </div>
            </div>
            <VersionTab
              projectId={projectId}
              projectDetail={projectDetail}
              version={version}
              deleteFlag={permissionsArray.includes(PROJECT_VERSION)}
            />
          </>
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProjectVersion);
